import styles from "./Ecosystem.module.css";
import {
  FaTrophy,
  FaBook,
  FaChartLine,
  FaLaptopCode,
  FaChalkboardTeacher,
  FaRobot,
} from "react-icons/fa";
import competitions from "../../../assets/images/school_programmes/fields/competitions.png";
import curriculum from "../../../assets/images/school_programmes/fields/curriculum.png";
import assessment from "../../../assets/images/school_programmes/fields/assessment.png";
import coding from "../../../assets/images/school_programmes/fields/coding.png";
import teacher from "../../../assets/images/school_programmes/fields/teacher.png";
import robotics from "../../../assets/images/school_programmes/fields/robotics.png";

const Ecosystem = () => {
  const ecosystemItems = [
    {
      icon: <FaTrophy />,
      title: "International Competitions & Innovation Festival",
      description:
        "A global platform that showcases young innovators through competitions and an innovation festival.",
      image: competitions,
    },
    {
      icon: <FaBook />,
      title: "Structured Curriculum with LMS System",
      description:
        "An integrated curriculum supported by a Learning Management System for effective learning.",
      image: curriculum,
    },
    {
      icon: <FaChartLine />,
      title: "Plode Learning & Assessment System",
      description:
        "A comprehensive system to track student progress and performance through assessments.",
      image: assessment,
    },
    {
      icon: <FaLaptopCode />,
      title: "Coding and AI Platform",
      description:
        "A platform designed to equip students with future-ready programming and AI skills.",
      image: coding,
    },
    {
      icon: <FaChalkboardTeacher />,
      title: "Teacher Development Program",
      description:
        "A program aimed at empowering educators with the skills and knowledge they need.",
      image: teacher,
    },
    {
      icon: <FaRobot />,
      title: "Hands-On AI and Robotics Kits",
      description:
        "Interactive kits that provide hands-on learning experiences in AI and robotics.",
      image: robotics,
    },
  ];

  return (
    <section className={styles.ecosystem}>
      <div className={styles.container}>
        <h2 className={styles.title} data-aos="fade-up">
          A Unique Ecosystem for <span>Holistic 21st Century Education</span>
        </h2>
        <p className={styles.subtitle} data-aos="fade-up">
          Our comprehensive ecosystem integrates cutting-edge technology,
          structured learning, and hands-on experience to prepare students for
          the future of innovation and technology.
        </p>

        <div className={styles.grid}>
          {ecosystemItems.map((item, index) => (
            <div
              key={index}
              className={styles.card}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className={styles.cardContent}>
                <div
                  className={styles.cardImage}
                  style={{ backgroundImage: `url(${item.image})` }}
                />
                <div className={styles.cardText}>
                  <h3 className={styles.cardTitle}>{item.title}</h3>
                  <p className={styles.cardDescription}>{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Ecosystem;
